<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { AppDatePicker, InputPrimary } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalDisciplineSetupLessons } from '../../model/modal-discipline-setup-lessons.hook'

defineOptions({
  name: 'ModalDisciplineSetupLessons',
})

const {
  refCount,
  refUnscheduled,
  refCountMode,
  refCountError,
  refStartDate,
  refMinDate,
  refIsDisabled,
  refIsSaving,
  setCount,
  setStartDate,
  close,
  confirm,
} = useModalDisciplineSetupLessons()
</script>

<template>
  <ModalDefault
    show
    :loading="refIsSaving"
    class-name="modal-discipline-schedule-step modal-discipline-setup-lessons-step"
    is-close-button
    @click:overlay="close"
    @click:close="close"
  >
    <div class="modal-discipline-setup-lessons">
      <AppText name="h3">
        Unscheduled lessons setup
      </AppText>
      <div class="modal-discipline-setup-lessons__section">
        <AppText
          name="body1"
          color="slate-700"
        >
          Choose the number of lessons to add to the schedule
        </AppText>
        <div class="modal-discipline-setup-lessons__count">
          <div class="modal-discipline-setup-lessons__count-input">
            <InputPrimary
              id="setup_lessons_count"
              type="number"
              label="Number of lessons"
              placeholder="123"
              required
              :min="0"
              :value="refCount"
              :mode="refCountMode"
              @update:value="setCount"
            />
            <AppText
              v-if="refCountError"
              name="body2"
              color="red-600"
            >
              {{ refCountError }}
            </AppText>
          </div>
          <div class="modal-discipline-setup-lessons__count-total">
            <AppText
              name="body1"
              color="slate-500"
            >
              of
            </AppText>
            <AppText name="h3">
              {{ refUnscheduled }}
            </AppText>
            <AppText
              name="body1"
              color="slate-700"
            >
              Unscheduled lessons
            </AppText>
          </div>
        </div>
        <AppDatePicker
          label="Set up start date"
          placeholder="Select here"
          required
          :value="refStartDate"
          :min-date="refMinDate"
          @change="setStartDate"
        />
      </div>
      <div class="modal-discipline-setup-lessons__hint">
        <p>💡 If a lesson is placed on a:</p>
        <ol>
          <li>Reserved slot → lesson is created, reservation shifts to end of the month</li>
          <li>Confirmed lesson slot → lesson is created with <strong>Planned</strong> status</li>
        </ol>
        <p>Lessons will follow the student's weekly schedule</p>
      </div>
    </div>
    <template #controls>
      <BtnPrimary
        text="Confirm"
        color="emerald"
        :disabled="refIsDisabled || refIsSaving"
        @click="confirm"
      />
      <BtnSecondary
        text="Cancel"
        color="black"
        :disabled="refIsSaving"
        @click="close"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineSchedule.scss" />
<style scoped lang="scss" src="./ModalDisciplineSetupLessons.scss" />
